import { AddCircleOutline, CloseOutlined, Delete, FormatListBulleted } from "@mui/icons-material";
import { Box, Button, Checkbox, IconButton, MenuItem, Modal, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Url } from "../../constants";
import Swal from "sweetalert2";
import Loader from "../../Layout/Loader/Loaders";
import { useNavigate } from "react-router-dom";

const AdmonRoles = () => {

    const token = localStorage.getItem("token")
    const [isCharging, setisCharging] = useState(false)
    const user_datos = JSON.parse(localStorage.getItem("user"))
    const Navigate = useNavigate()

    const [selectRol, setselectRol] = useState(-1)
    const [disabled_save, setdisabled_save] = useState(true)
    
    //Catálogos
    const [roles, setroles] = useState([])
    const [catalogo_roles_ini, setcatalogo_rol_ini] = useState([])
    const [openRoles, setopenRoles] = useState(false)

    const [catalogo_pantallas, setcatalogo_pantallas] = useState([])
    const [catalogo_pant_ini, setcatalogo_pant_ini] = useState([])
    const [openPant, setopenPant] = useState(false)

    const getRoles = async() => {
        setisCharging(true)

        await axios.get(Url + "GetRoles", {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setroles(res.data.Roles)
            setcatalogo_rol_ini(res.data.Roles)
            setisCharging(false)
        })
        .catch(err => {
            console.log(err)
            setisCharging(false)
        })
    }

    const getPantallas = async() => {
        setisCharging(true)

        await axios.get(Url + "GetPantallas", {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setcatalogo_pantallas(res.data.Pantallas)
            setcatalogo_pant_ini(res.data.Pantallas)
            setisCharging(false)
        })
        .catch(err => {
            console.log(err)
            setisCharging(false)
        })
    }

    const getRoleById = async (id_select_rol) => {
        setisCharging(true)

        await axios.get(Url + "GetRol?id="+id_select_rol, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setpantallas_rol(res.data)
            settotalini(res.data.length)
            setisCharging(false)

            if (res.data.length < 1) {
                Swal.fire("Sin Registro de Datos aún","","info")
            }
            
        })
        .catch(err => {
            console.log(err)
            setisCharging(false)
        })
    }

    useEffect(() => {
        if (token && !["null", "undefined"].includes(token) && user_datos.roluser_id === 1) {
            getRoles()
            getPantallas()
        } else {
            localStorage.clear()
            Navigate("/login")
        }
    },[])

    //Variables para la tabla de pantallas_permisos
    const [total_inical_registros, settotalini] = useState(0);
    const [pantallas_rol, setpantallas_rol] = useState([])

    const handleChangeSelectRol = async (event) => {
        const value = event.target.value
        setselectRol(value)
        settotalini(pantallas_rol.length)

        getRoleById(value)
        setdisabled_save(true)
    }
    const agregarRegistrosRol_Pantalla = async () => {
        setisCharging(true)

        const name_rol = roles.find(obj => obj.id === selectRol);

        try {
            for (let index = total_inical_registros; index < pantallas_rol.length; index++) {
                const copyByObjt = {rol: name_rol.rol, pantalla: pantallas_rol[index].pantalla.pantalla, 
                    permisos: pantallas_rol[index].permisos}

                await axios.post(Url + "RolPermisoP", copyByObjt,{
                    headers: {
                        Authorization: token
                    }
                })
            }

            setisCharging(false)
            Swal.fire("Pantallas Agregadas al rol correctamente","","success")

            getRoleById(selectRol)
            setdisabled_save(true)
            
        } catch (error) {
            console.log(error)
            setisCharging(false)
        }

        setdisabled_save(true)
    }

    //Métodos de Catálogo Roles
    const closeModalRoles = async () => {
        setopenRoles(false)

        if (roles.length !== catalogo_roles_ini.length) {
            setroles(catalogo_roles_ini)
        }
    }
    const addNewRol = () => {
        const copyRoles = [...roles]
        copyRoles.push({id:0, rol:" "})

        setroles(copyRoles)
    }
    const handleChangeNameRolNew = (event, index_rol) => {
        const copy_R = [...roles]
        const value = event.target.value

        copy_R[index_rol].rol = value
        setroles(copy_R)
    }
    const addAllNewRoles = async () => {
        try {
            for (let index = catalogo_roles_ini.length; index < roles.length; index++) {
                await axios.post(Url + "CrearRol?rol=" + roles[index].rol, "", {
                    headers:{
                        Authorization: token
                    }
                })
            }

            Swal.fire({
                title: "Roles creados correctamente",
                icon: "success",
                backdrop: false,
                didOpen: () => {
                  document.querySelector(".swal2-container").style.zIndex = "1400";
                }
            });
            getRoles()
        } catch (error) {
            console.log(error)
            Swal.fire({
                title: "Error al crear los roles",
                icon: "error",
                backdrop: false,
                didOpen: () => {
                  document.querySelector(".swal2-container").style.zIndex = "1400";
                }
            });
        }
    }

    const deleteRol = async (id_rol_delete) => {
        const responseSwal = await Swal.fire({
            title: "¿Está seguro de eliminar el rol?",
            icon: "question",
            showConfirmButton: true,
            confirmButtonColor:"#229954",
            showCancelButton: true,
            cancelButtonColor:"#e74c3c",
            backdrop: false,
            didOpen: () => {
              document.querySelector(".swal2-container").style.zIndex = "1400";
            }
        })
        
        if (responseSwal.isConfirmed) {
            try {
                await axios.delete(Url + "DeleteRol/" + id_rol_delete, {
                    headers:{
                        Authorization: token
                    }
                })

                Swal.fire({
                    title: "Rol eliminado correctamente",
                    icon: "success",
                    backdrop: false,
                    didOpen: () => {
                      document.querySelector(".swal2-container").style.zIndex = "1400";
                    }
                });
    
                getRoles()
            } catch (error) {
                console.log(error);
                Swal.fire("Error al eliminar el rol","","error");
            }
        }
    }
    const cancelRegistroRol = (index_rol) => {
        const copyallroles = [...roles]
        copyallroles.splice(index_rol, 1)
        setroles(copyallroles)
    }

    //Métodos Catálogo Pantallas
    const closeModalPantallas = async () => {
        setopenPant(false)

        if (catalogo_pantallas.length !== catalogo_pant_ini.length) {
            setcatalogo_pantallas(catalogo_pant_ini)
        }
    }
    const addNewPantalla = () => {
        const copy_Pant = [...catalogo_pantallas]
        copy_Pant.push({id:0, pantalla:""})

        setcatalogo_pantallas(copy_Pant)
    }
    const handleChangeNamePantallaNew = (event, index_pantalla) => {
        const copy_Pant = [...catalogo_pantallas]
        const value = event.target.value

        copy_Pant[index_pantalla].pantalla = value
        setcatalogo_pantallas(copy_Pant)
    }
    const addAllNewPantallas = async () => {
        try {
            for (let index = catalogo_pant_ini.length; index < catalogo_pantallas.length; index++) {
                await axios.post(Url + "CrearPantalla?pantalla=" + catalogo_pantallas[index].pantalla, "", {
                    headers:{
                        Authorization: token
                    }
                })
            }

            Swal.fire({
                title:"Pantalla creada correctamente",
                icon:"success",
                backdrop: false,
                didOpen: () => {
                  document.querySelector(".swal2-container").style.zIndex = "1400";
                }
            });
            getPantallas()
        } catch (error) {
            console.log(error)
            Swal.fire({
                title:"Error al crear las Pantallas",
                icon:"error",
                backdrop: false,
                didOpen: () => {
                  document.querySelector(".swal2-container").style.zIndex = "1400";
                }
            });
        }
    }
    const deletePantalla = async (id_pantalla_delete) => {
        const responseSwal = await Swal.fire({
            title: "¿Está seguro de eliminar la pantalla?",
            icon: "question",
            showConfirmButton: true,
            confirmButtonColor:"#229954",
            showCancelButton: true,
            cancelButtonColor:"#e74c3c",
            backdrop: false,
            didOpen: () => {
              document.querySelector(".swal2-container").style.zIndex = "1400";
            }
        })
        
        if (responseSwal.isConfirmed) {
            try {
                await axios.delete(Url + "DeletePantalla/" + id_pantalla_delete, {
                    headers:{
                        Authorization: token
                    }
                })

                Swal.fire({
                    title: "Pantalla eliminada correctamente",
                    icon: "success",
                    backdrop: false,
                    didOpen: () => {
                      document.querySelector(".swal2-container").style.zIndex = "1400";
                    }
                });
    
                getPantallas()
            } catch (error) {
                Swal.fire("Error al eliminar la pantalla","","error");
            }
        }
    }
    const cancelNewPantalla = (index_pantalla_cancel) => {
        const copyPantallasCancel = [...catalogo_pantallas]
        copyPantallasCancel.splice(index_pantalla_cancel, 1)
        setcatalogo_pantallas(copyPantallasCancel)
    }

    //Métodos de Tabla
    const addNewPantalla_Permisos = () => {
        setdisabled_save(false)

        const copy_pantallas_rol = [...pantallas_rol]
        copy_pantallas_rol.push({pantalla:{id:0, pantalla:" "}, permisos:[]})
        setpantallas_rol(copy_pantallas_rol)
    }
    const handleChangeSelectPantalla = (event, id) => {
        const copy_pantallas_rol2 = [...pantallas_rol]
        const value = event.target.value

        copy_pantallas_rol2[id].pantalla.pantalla = value
        setpantallas_rol(copy_pantallas_rol2)
    }
    const checkedPermisos = (event, id) => {
        const copy_pantallas_rol3 = [...pantallas_rol]
        const value = event.target.value

        if (event.target.checked) {
            copy_pantallas_rol3[id].permisos.push(value)
        } else {
            let index_delete = copy_pantallas_rol3[id].permisos.indexOf(value)
            copy_pantallas_rol3[id].permisos.splice(index_delete, 1)
        }
        setpantallas_rol(copy_pantallas_rol3)
    }
    const deletePantallaRol = async (id_pantalla) => {
        setisCharging(true)
        await axios.delete(Url + "DeletePantallaR?rol="+selectRol+"&pantalla="+id_pantalla, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            getRoleById(selectRol)
            Swal.fire(res.data.message, "", "success")
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    //Estilos
    const styleRowHead = {
        color: "white",
        fontSize: "15px",
        fontWeight: "bold",
        textAlign: "center",
        backgroundColor:"#212f3d"
    }

    const styleRowBody = {
        textAlign: "center",
    }

    //Modal
    const styleModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        height: '70vh',
        bgcolor: 'background.paper',
        p: 4,
      };

      const sRowMRoles = {
        bgcolor: "#49ff00",
        fontSize: "15px",
        fontWeight: "bold",
      }

    return (
        <div style={{margin:"10px", display:"flex", flexDirection:"column", alignItems:"center",
            overflow:"hidden", height:"calc(100vh - 20px)"
        }}>
            <h2>Administración de Roles</h2>
            <Box sx={{display:"flex", justifyContent:"space-between", width:"90%", m:"20px 0px 20px 0px"}}>
                <Box sx={{display:"flex", gap:2, alignItems:"center"}}>
                    <label>Rol: </label>
                    <Select 
                        variant="standard"
                        value={selectRol}
                        sx={{width:"200px"}}
                        onChange={(handleChangeSelectRol)}
                    >
                        <MenuItem value={-1} disabled>--Seleccione--</MenuItem>
                        {roles.map((rol) => (
                            <MenuItem value={rol.id} key={rol.id}>{rol.rol}</MenuItem>
                        ))}
                    </Select>

                    <Tooltip title="Catálogo Roles" arrow placement="right">
                        <IconButton size="small" sx={{border:"1px solid"}} onClick={() => setopenRoles(true)}>
                            <FormatListBulleted fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Button variant="contained" color="success" onClick={agregarRegistrosRol_Pantalla}
                disabled={disabled_save}>
                    Guardar Registros</Button>
            </Box>

            {/* CATÁLOGO DE ROLES */}
            <Modal open={openRoles} onClose={closeModalRoles}>
                <Box sx={styleModal}>
                    <Box sx={{display:"flex", justifyContent:"space-between", mb:2}}>
                        <h2>Catálogo de Roles</h2>

                        <div style={{display:"flex", alignItems:"center", gap:10}}>
                            <Button size="small" variant="contained" color="success" onClick={addAllNewRoles}
                            disabled={!(roles.length > catalogo_roles_ini.length)}>
                                GUARDAR
                            </Button>

                            <Button size="small" variant="outlined" color="error"
                            onClick={closeModalRoles}>
                                X</Button>
                        </div>
                    </Box>

                    <TableContainer sx={{maxHeight:{md:"50vh", lg:"58vh"}, overflow:"auto"}}>
                        <Table stickyHeader sx={{border:"1px solid"}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={sRowMRoles}>ID</TableCell>
                                    <TableCell sx={{...sRowMRoles, width:"80%"}}>Nombre</TableCell>
                                    <TableCell sx={{...sRowMRoles, textAlign:"center"}}>Acciones</TableCell>
                                    <TableCell sx={sRowMRoles}>
                                        <IconButton size="small" onClick={addNewRol}>
                                            <AddCircleOutline />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {roles.map((rol, index_rol) => (
                                    <TableRow key={index_rol}>
                                        <TableCell>{rol.id}</TableCell>
                                        <TableCell>
                                            {rol.id !== 0 ?
                                                rol.rol
                                                :
                                                <TextField variant="standard" value={rol.rol} 
                                                onChange={(e) => handleChangeNameRolNew(e, index_rol)}/>
                                            }
                                        </TableCell>
                                        <TableCell sx={{display:"flex", gap:1, justifyContent:"center"}}>
                                            <IconButton sx={{border:"1px solid"}} color="error" size="small"
                                            onClick={() => rol.id !== 0 ? deleteRol(rol.id) : cancelRegistroRol(index_rol)}>
                                                {rol.id !== 0 ?
                                                <Delete fontSize="small"/>
                                                :
                                                <CloseOutlined fontSize="small"/>
                                                }
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{width:0}}></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>

            {/* CATÁLOGO DE PANTALLAS */}
            <Modal open={openPant} onClose={closeModalPantallas}>
                <Box sx={styleModal}>
                    <Box sx={{display:"flex", justifyContent:"space-between", mb:2}}>
                        <h2>Catálogo de Pantallas</h2>

                        <div style={{display:"flex", alignItems:"center", gap:10}}>
                            <Button size="small" variant="contained" color="success" onClick={addAllNewPantallas}
                            disabled={!(catalogo_pantallas.length > catalogo_pant_ini.length)}>
                                GUARDAR
                            </Button>
                            <Button size="small" variant="outlined" color="error"
                            onClick={closeModalPantallas}>
                                X</Button>
                        </div>
                    </Box>

                    <TableContainer sx={{maxHeight:{md:"50vh", lg:"58vh"}, overflow:"auto"}}>
                        <Table stickyHeader sx={{border:"1px solid"}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={sRowMRoles}>ID</TableCell>
                                    <TableCell sx={{...sRowMRoles, width:"80%"}}>Nombre</TableCell>
                                    <TableCell sx={{...sRowMRoles, textAlign:"center"}}>Acciones</TableCell>
                                    <TableCell sx={sRowMRoles}>
                                        <IconButton size="small" onClick={addNewPantalla}>
                                            <AddCircleOutline />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {catalogo_pantallas.map((pantalla, index_pantalla) => (
                                    <TableRow key={index_pantalla}>
                                        <TableCell>{(index_pantalla+1)}</TableCell>
                                        <TableCell>
                                            {pantalla.id !== 0 ?
                                                pantalla.pantalla
                                                :
                                                <TextField variant="standard" value={pantalla.pantalla} 
                                                onChange={(e) => handleChangeNamePantallaNew(e, index_pantalla)}/>
                                            }
                                        </TableCell>
                                        <TableCell sx={{display:"flex", gap:1, justifyContent:"center"}}>
                                            <IconButton sx={{border:"1px solid"}} color="error" size="small"
                                            onClick={() => pantalla.id !== 0 ? deletePantalla(pantalla.id) : cancelNewPantalla(index_pantalla)}>
                                                {pantalla.id !== 0 ?
                                                    <Delete fontSize="small" />
                                                    :
                                                    <CloseOutlined fontSize="small" /> 
                                                }
                                            </IconButton>
                                        </TableCell>
                                        <TableCell sx={{width:0}}></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>

            {/*TABLA DE REGISTROS PANTALLA_PERMISOS*/}
            <TableContainer>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{...styleRowHead, width:"70%",}}>
                                Pantalla
                                <Tooltip title="Catálogo Roles" arrow placement="right">
                                    <IconButton size="small" sx={{border:"1px solid white", ml:2}}
                                    onClick={() => setopenPant(true)}>
                                        <FormatListBulleted fontSize="small" sx={{color:"white"}}/>
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell sx={styleRowHead}>Crear</TableCell>
                            <TableCell sx={styleRowHead}>Leer</TableCell>
                            <TableCell sx={styleRowHead}>Actualizar</TableCell>
                            <TableCell sx={styleRowHead}>Eliminar</TableCell>
                            <TableCell sx={styleRowHead}>Descargar</TableCell>
                            <TableCell sx={styleRowHead}>Aciones</TableCell>
                            <TableCell sx={styleRowHead}>
                                <IconButton size="small" sx={{color:"white"}} onClick={addNewPantalla_Permisos}
                                disabled={selectRol === -1}>
                                    <AddCircleOutline />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    {pantallas_rol.length > 0 &&
                    <TableBody sx={{height:"200px", overflowY:"auto"}}>
                        {pantallas_rol.map((pantalla, index_pantalla) => (
                            <TableRow key={index_pantalla}>
                                <TableCell>
                                    {index_pantalla < total_inical_registros ?
                                        pantalla.pantalla.pantalla
                                        :
                                        <Select
                                            variant="standard"
                                            value={pantalla.pantalla.pantalla}
                                            sx={{width:"90%"}}
                                            onChange={(e) => handleChangeSelectPantalla(e, index_pantalla)}
                                        >
                                            <MenuItem value=" " disabled>--Seleccione--</MenuItem>
                                            {catalogo_pantallas.map((c_pantalla, index_catalogo) => (
                                                <MenuItem value={c_pantalla.pantalla} key={index_catalogo}>
                                                    {c_pantalla.pantalla}</MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </TableCell>
                                {["crear","vista","actualizar","eliminar","descargar"].map((accion, index_a) => (
                                    <TableCell sx={styleRowBody} key={index_a}>
                                        <Checkbox size="small" checked={pantalla.permisos.includes(accion)}
                                        onChange={(e) => checkedPermisos(e, index_pantalla)}
                                        disabled={index_pantalla < total_inical_registros} value={accion}
                                        />
                                    </TableCell>     
                                ))}
                                <TableCell sx={{...styleRowBody, width:0}}>
                                    <Tooltip title="Eliminar" placement="right" arrow>
                                        <IconButton color="error" sx={{border:"1px solid"}} size="small"
                                        onClick={() => deletePantallaRol(pantalla.pantalla.id)}>
                                            <Delete fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sx={{width:0}}></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>}
                </Table>
            </TableContainer>

        {isCharging && <Loader />}
        
        </div>
    )
}

export default AdmonRoles;